import Header from '../../blocks/header/scripts.js'
import Hero from '../../blocks/hero/scripts.js'
import DoubleImg from '../../blocks/double-img/scripts.js'
import Blog from '../../blocks/blog/scripts.js'
import Cards from '../../blocks/cards/scripts.js'
import TitleCta from '../../blocks/title-cta/scripts.js'
import DoubleSlider from '../../blocks/double-slider/scripts.js'
import TripleImage from '../../blocks/triple-image/scripts.js'
import PictoList from '../../blocks/picto-list/scripts.js'
import HeroSlider from '../../blocks/hero-slider/scripts.js'
import TextVideo from '../../blocks/text-video/scripts.js'
import Contact from '../../blocks/contact/scripts.js'
import { initReveal } from './utils/reveal.js'
import initParallax from './utils/parallax.js'
import initDrawLines from './utils/draw-lines.js'

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.header').forEach(el => new Header(el))
  document.querySelectorAll('.hero').forEach(el => new Hero(el))
  document.querySelectorAll('.double-image').forEach(el => new DoubleImg(el))
  document.querySelectorAll('.blog--masonry').forEach(el => new Blog(el))
  document.querySelectorAll('.cards').forEach(el => new Cards(el))
  document.querySelectorAll('.title-cta').forEach(el => new TitleCta(el))
  document.querySelectorAll('.double-slider').forEach(el => new DoubleSlider(el))
  document.querySelectorAll('.triple-image').forEach(el => new TripleImage(el))
  document.querySelectorAll('.picto-list').forEach(el => new PictoList(el))
  document.querySelectorAll('.hero-slider').forEach(el => new HeroSlider(el))
  document.querySelectorAll('.text-video').forEach(el => new TextVideo(el))
  document.querySelectorAll('.contact').forEach(el => new Contact(el))

  initReveal()
  initParallax()
  initDrawLines()
});